<template>
        <authentication></authentication>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import Authentication from '@/components/auth/Authentication';

    @Component
    export default class AuthenticationPage extends Vue {
        name = 'authentication-page';
    }

    Vue.component('authentication-page', AuthenticationPage);
</script>



// WEBPACK FOOTER //
// src/pages/AuthenticationPage.vue